var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiltedLogomark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 171,
    viewBox: "0 0 290 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_6597_9535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.415 208.383L116.592 190.554C146.116 181.827 163.639 156.168 151.704 114.546L147.812 100.971C128.716 36.3813 67.4965 10.7181 2.98483 28.9641L30.0627 123.396C33.3693 134.927 40.3768 160.549 78.0755 149.739L90.0815 146.297L90.9462 149.312L62.4149 157.493C50.8833 160.8 44.2185 172.824 47.5251 184.355L54.415 208.383Z",
    fill: "#E5554F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.051 141.677L224.874 159.506C195.212 167.751 166.754 155.277 154.818 113.654L150.926 100.08C132.884 35.1875 171.21 -19.0201 235.588 -37.7326L262.666 56.6991C265.973 68.2307 273.608 93.6726 235.909 104.483L223.903 107.925L224.768 110.941L253.299 102.76C264.83 99.4529 276.854 106.118 280.161 117.649L287.051 141.677Z",
    fill: "#E5554F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6597_9535",
    x: 0.473905,
    y: -40.2312,
    width: 289.068,
    height: 251.109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24742,
    result: "effect1_foregroundBlur_6597_9535"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiltedLogomark);
export default __webpack_public_path__ + "static/media/tilted-logomark.e328c8a9347c5b96801ede01ba9c2753.svg";
export { ForwardRef as ReactComponent };